/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StoreManagementDeleteItemResponse } from './StoreManagementDeleteItemResponse';

export type StoreManagementDeleteItemResponseApiRespoonse = {
    data?: StoreManagementDeleteItemResponse;
    status?: StoreManagementDeleteItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace StoreManagementDeleteItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

